import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { changePassword, logoutAuth } from '../../redux/reducers/AuthSlice';
import {
  validateChangePassword,
  validateProfileUpdate,
} from '../../utils/validaiton';
import Toast from '../../utils/toast';
import { updateProfile } from '../../redux/reducers/ProfileSlice';

const MyProfile = ({ profileData }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [profileEdit, setProfileEdit] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const handleLogout = () => {
    dispatch(logoutAuth());
    navigate('/login');
  };
  const [changePasswordData, setChangePasswordData] = useState({
    oldPassword: '',
    newPassword: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordData({
      ...changePasswordData,
      [name]: value,
    });
    setErrors((error) => {
      let errorNew = { ...error };
      delete errorNew[name];
      return errorNew;
    });
  };
  const handleSubmitChangePassword = async (e) => {
    e.preventDefault();
    const error = validateChangePassword(changePasswordData);
    if (Object.keys(error).length) {
      setErrors(error);
      return;
    }
    const payload = {
      old_password: changePasswordData.oldPassword,
      new_password: changePasswordData.newPassword,
    };

    const changePasswordResponse = await dispatch(changePassword(payload));
    if (!changePasswordResponse.payload) {
      Toast('error', 'Invalid password');
      return;
    }
    if (changePasswordResponse.payload.success) {
      Toast('success', 'Password change successfully');
      setChangePasswordData({
        oldPassword: '',
        newPassword: '',
      });
      handleLogout();
    } else {
      Toast('error', changePasswordResponse.payload.msg || 'Failed');
    }
  };

  const [formData, setFormData] = useState(profileData || {});

  useEffect(() => {
    if (profileData) {
      setFormData(profileData);
    }
  }, [profileData]);

  const handlePrfoileChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors((error) => {
      let errorNew = { ...error };
      delete errorNew[name];
      return errorNew;
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (!file) return;  // Ensure a file is selected
    
    const validTypes = ['image/jpeg', 'image/png'];
    
    if (!validTypes.includes(file.type)) {
      Toast('error', 'Invalid file type. Only JPG and PNG are allowed.');
      return;
    }
  
    // Set image preview URL (for UI preview purposes)
    const imagePreviewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(imagePreviewUrl);
  
    // Ensure the file is stored in the formData state
    setFormData({
      ...formData,
      image: file,  // Store the file object in formData
    });
  
    setAttachments([file]);
  };
  
  
  

  const handleSubmitUpdateProfile = async (e) => {
    e.preventDefault();
    const error = validateProfileUpdate(formData);
    if (Object.keys(error).length) {
      setErrors(error);
      return;
    }
  
    const formDataToSend = new FormData();
  
    Object.keys(formData).forEach((key) => {
      if (key !== 'image') {
        formDataToSend.append(key, formData[key]);
      }
    });
  
    // Append image ONLY if the user has selected a new one
    if (imagePreviewUrl) {
      formDataToSend.append('image', formData.image);
    }
  
    const updateProfileResponse = await dispatch(updateProfile(formDataToSend));
    if (updateProfileResponse.payload && updateProfileResponse.payload.success) {
      Toast('success', 'Profile updated successfully');
      setProfileEdit(false);
      setImagePreviewUrl(null);
    } else {
      Toast('error', updateProfileResponse.payload.msg || 'Failed');
    }
    
    window.location.reload();
  };
  
  

  return (
    <>
      {profileEdit ? (
        <div className="dashboard_profile">
          <h5>Edit Profile info</h5>
          <form className="mb_50" onSubmit={handleSubmitUpdateProfile}>
            <button className="edit-btn" onClick={() => setProfileEdit(false)}>
              Cancel
            </button>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData?.name}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your first name"
                  />
                  <p className="error-msg">{errors.name}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Last ame</label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData?.last_name}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your Last name"
                  />
                  <p className="error-msg">{errors.last_name}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    value={formData?.phone}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your phone "
                  />
                  <p className="error-msg">{errors.phone}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Email</label>
                  <input
                    type="text"
                    name="email"
                    value={formData?.email}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your email"
                  />
                  <p className="error-msg">{errors.email}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Weight</label>
                  <input
                    type="text"
                    name="weight"
                    value={formData?.weight}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your weight"
                  />
                  <p className="error-msg">{errors.weight}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Gender</label>
                  <select
                    name="gender"
                    value={formData?.gender}
                    onChange={handlePrfoileChange}
                    className="gender-select"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  <p className="error-msg">{errors.gender}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard_profile_form">
                  <label>Age</label>
                  <input
                    type="text"
                    name="age"
                    value={formData?.age}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your age"
                  />
                  <p className="error-msg">{errors.age}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="dashboard_profile_form">
                  <label>Address</label>
                  <input
                    type="text"
                    name="address"
                    value={formData?.address}
                    onChange={handlePrfoileChange}
                    placeholder="Enter your address"
                  />
                  <p className="error-msg">{errors.address}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="dashboard_profile_form">
                  <label className="app-label">Profile Image</label>
                  <input
                    name="image"
                    type="file"
                    onChange={handleFileChange}
                    accept=".jpg, .jpeg, .png, .pdf"
                  />
                  <p className="error-msg">{errors.report_image}</p>
                  {formData.image && (
                    <div>
                      {imagePreviewUrl ? (
                        <>
                          <img
                            src={imagePreviewUrl}
                            alt="Profile Preview"
                            style={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            src={formData.image}
                            alt="Profile Preview"
                            style={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <button type="submit" className="common_btn">
                  Save Change
                </button>
              </div>
            </div>
          </form>
          <h5>Change password</h5>
          <form onSubmit={handleSubmitChangePassword}>
            <div className="row">
              <div className="col-md-6">
                <div className="dashboard_profile_form">
                  <label>old Password</label>
                  <input
                    type="text"
                    placeholder="Old Password"
                    name="oldPassword"
                    value={changePasswordData.oldPassword}
                    onChange={(e) => handleChange(e)}
                  />
                  <p className="error-msg">{errors.oldPassword}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="dashboard_profile_form">
                  <label>new Password</label>
                  <input
                    type="text"
                    placeholder="New Password"
                    onChange={(e) => handleChange(e)}
                    name="newPassword"
                    value={changePasswordData.newPassword}
                  />
                  <p className="error-msg">{errors.newPassword}</p>
                </div>
              </div>
              <div className="col-xl-12">
                <button type="submit" className="common_btn">
                  Save Change
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="dashboard_profile">
          <h5>Profile information</h5>
          <button className="edit-btn" onClick={() => setProfileEdit(true)}>
            edit
          </button>
          <ul>
            <li>
              <span>Name:</span> {formData?.name} {formData?.last_name}
            </li>
            <li>
              <span>Phone:</span> {formData?.country_code} {formData?.phone}
            </li>
            <li>
              <span>Email:</span> {formData?.email}
            </li>
            <li>
              <span>Gender:</span> {formData?.gender}
            </li>
            <li>
              <span>Weight:</span> {formData?.weight}
            </li>
            <li>
              <span>Age:</span> {formData?.age}
            </li>
            <li>
              <span>Address:</span> {formData?.address}
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default MyProfile;
